import Code from 'react-qr-code'
import css from './QRCode.module.css'

const QRCode = ({ url }) => (
  <div className={css.code}>
    <Code value={url} />
  </div>
)

export default QRCode
